import Icon from '@components/icon';
import pluralize from 'ati-utils/pluralize';
import cn from 'clsx';
import { observer } from 'mobx-react-lite';

import { useStore } from 'hooks/useStore';
import { RootStore } from 'store/RootStore';
import { PopupIds } from 'store/UIStore/Popups';
import { tabIds } from 'store/UIStore/UIStore';

import css from './GroupOperations.module.css';

type SelectedLoadsSources = {
  [key: string]: 'app' | 'favorites';
};

const selectedLoadsSources: SelectedLoadsSources = {
  [tabIds.search]: 'app',
  [tabIds.favorites]: 'favorites',
};

const GroupOperations = () => {
  const store = useStore();
  const {
    app: { i18n, hideSelectedLoads },
    view,
    profile,
    ui,
    favorites,
  } = store;

  const selectedLoadsSource: keyof RootStore = selectedLoadsSources[ui.activeTab] || 'app';
  const selectedLoads = store[selectedLoadsSource].selectedLoads;

  const handlePrintLoads = () => {
    const isLoggedIn = profile.data?.isUser;

    if (isLoggedIn) {
      ui.setPrintMode(true);
    } else {
      ui.popups.open(PopupIds.loginPopup);
    }
  };

  const handleHideLoads = () => {
    if (!profile.data?.isUser) {
      ui.popups.open(PopupIds.loginPopup);
      return;
    }

    hideSelectedLoads();
  };

  const shouldShowHideButton = ui.activeTab === tabIds.search;

  const shouldShowRemoveFromFavorites = ui.activeTab === tabIds.favorites;

  return (
    <div className={cn(css.groupOperations, { hidden: !selectedLoads.count })}>
      <div className={css.infoTextContainer}>
        <p className={css.infoText}>
          {pluralize({ value: selectedLoads.count, ...i18n.app.declensions.selected })}{' '}
          {view.pluralizedCount(selectedLoads.count, 'loads')}
        </p>
        <button className={css.iconButton} onClick={selectedLoads.unselectAll}>
          <Icon color="var(--dark-gray)" height="14" name="ic_none" width="14" />
        </button>
      </div>

      <div className={css.operations}>
        <button
          className={cn(css.primaryOperation, 'glz-button glz-is-primary glz-is-outlined glz-is-small')}
          onClick={handlePrintLoads}
        >
          {i18n.app.print}
        </button>

        {shouldShowHideButton && (
          <button
            className={cn(css.secondaryOperation, 'glz-button glz-is-primary glz-is-small')}
            onClick={handleHideLoads}
          >
            {i18n.app.hide}
          </button>
        )}

        {shouldShowRemoveFromFavorites && (
          <button
            className={cn(css.secondaryOperation, 'glz-button glz-is-primary glz-is-small')}
            onClick={favorites.removeSelectedFavorites}
          >
            {i18n.app.delete}
          </button>
        )}
      </div>
    </div>
  );
};

const connected = observer(GroupOperations);

export { connected as GroupOperations };
